import React from 'react';
import { Multiselect } from 'fw/forms';
import * as API from 'modules/app/API'

class CertificationUnassignedVoters extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = { ...this.initialState(), loading: true }
    }

    initialState = () => {

        let rq = {
            certificationId: this.props.certificationId
        };

        API.Admin.get('/queue/getCommitteeVoters', rq,
            {
                success: (r) => {
                    this.setState({
                        loading: false,
                        items: r.data.items.map((item) => { return { label: item.fullName, value: item.userId } })
                    }, () => {
                        if (this.props.onLoad)
                            this.props.onLoad(r.data.voters)
                    });
                }
            });
    }

    getSelectedVoters = () => {
        return this._control.getValue();
    }

    render() {
        if (this.state.loading)
            return null;

        return (
            <Multiselect
                ref={(c) => { this._control = c; }}
                {...this.props}
                items={this.state.items} />
        )
    }
}

export default CertificationUnassignedVoters;

// Mark this as a form component
CertificationUnassignedVoters.defaultProps = {
    formControl: true,
    managed: false
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/certificationUnassignedVoters/CertificationUnassignedVoters.js